import script from "./CountersPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CountersPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__